import React, { Component } from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon, CalendarIcon, TrophyIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const NewBusinessPipelineDashboard: React.FC = () => {
  const kpis = [{
    title: 'Pipeline Value',
    value: '₹4,850 Cr',
    change: '+18.5%',
    isPositive: true,
    subtitle: 'Total active opportunities'
  }, {
    title: 'Win Rate %',
    value: '38.5%',
    change: '+4.2%',
    isPositive: true,
    subtitle: 'Last 12 months'
  }, {
    title: 'SOP in Next 6 Months',
    value: '12',
    change: '+3',
    isPositive: true,
    subtitle: 'Confirmed projects'
  }];
  const funnelData = [{
    stage: 'RFQ Received',
    value: 4850,
    percentage: 100,
    count: 68,
    color: 'bg-blue-500'
  }, {
    stage: 'Tech Review',
    value: 3480,
    percentage: 72,
    count: 52,
    color: 'bg-blue-600'
  }, {
    stage: 'Quote Submitted',
    value: 2420,
    percentage: 50,
    count: 38,
    color: 'bg-green-500'
  }, {
    stage: 'Won / Awarded',
    value: 1865,
    percentage: 38,
    count: 22,
    color: 'bg-green-600'
  }];
  const sopTimelineData = [{
    project: 'Maruti Suzuki Fronx EV - LED Headlamp',
    oem: 'Maruti Suzuki',
    sop: 'Nov 2024',
    value: 185,
    status: 'On Track',
    month: 1
  }, {
    project: 'Tata Curvv - Tail Lamp Assembly',
    oem: 'Tata Motors',
    sop: 'Dec 2024',
    value: 220,
    status: 'On Track',
    month: 2
  }, {
    project: 'Hyundai Creta Facelift - Bumper',
    oem: 'Hyundai',
    sop: 'Jan 2025',
    value: 195,
    status: 'At Risk',
    month: 3
  }, {
    project: 'Mahindra XUV 3XO - Door Handles',
    oem: 'Mahindra',
    sop: 'Jan 2025',
    value: 165,
    status: 'On Track',
    month: 3
  }, {
    project: 'Kia Carens EV - Wiring Harness',
    oem: 'Kia',
    sop: 'Feb 2025',
    value: 145,
    status: 'On Track',
    month: 4
  }, {
    project: 'Honda Elevate - Interior Trim',
    oem: 'Honda',
    sop: 'Feb 2025',
    value: 128,
    status: 'On Track',
    month: 4
  }, {
    project: 'Toyota Urban Cruiser - Safety Systems',
    oem: 'Toyota',
    sop: 'Mar 2025',
    value: 142,
    status: 'On Track',
    month: 5
  }, {
    project: 'MG Comet EV - Battery Enclosure',
    oem: 'MG Motor',
    sop: 'Mar 2025',
    value: 118,
    status: 'On Track',
    month: 5
  }, {
    project: 'VW Taigun Facelift - Lighting',
    oem: 'VW Group',
    sop: 'Apr 2025',
    value: 135,
    status: 'On Track',
    month: 6
  }, {
    project: 'Renault Kiger EV - Polymer Parts',
    oem: 'Renault',
    sop: 'Apr 2025',
    value: 98,
    status: 'At Risk',
    month: 6
  }, {
    project: 'Nissan Magnite - ECU Module',
    oem: 'Nissan',
    sop: 'Apr 2025',
    value: 105,
    status: 'On Track',
    month: 6
  }, {
    project: 'Skoda Kushaq - Seat Components',
    oem: 'VW Group',
    sop: 'May 2025',
    value: 88,
    status: 'On Track',
    month: 7
  }];
  const oemProductLineData = [{
    oem: 'Maruti Suzuki',
    lighting: 285,
    polymer: 220,
    electrical: 195,
    safety: 165
  }, {
    oem: 'Hyundai',
    lighting: 245,
    polymer: 198,
    electrical: 178,
    safety: 142
  }, {
    oem: 'Tata Motors',
    lighting: 268,
    polymer: 185,
    electrical: 225,
    safety: 158
  }, {
    oem: 'Mahindra',
    lighting: 185,
    polymer: 165,
    electrical: 142,
    safety: 125
  }, {
    oem: 'Kia',
    lighting: 168,
    polymer: 145,
    electrical: 158,
    safety: 98
  }, {
    oem: 'Honda',
    lighting: 145,
    polymer: 128,
    electrical: 135,
    safety: 88
  }];
  const rfqStatusData = [{
    rfqNo: 'RFQ-2024-1847',
    oem: 'Maruti Suzuki',
    project: 'Swift Hybrid - LED Headlamp',
    productLine: 'Lighting',
    rfqDate: '15-Sep-2024',
    stage: 'Quote Submitted',
    value: 285,
    probability: 75,
    expectedSOP: 'Q2 FY26',
    owner: 'Rajesh Kumar',
    status: 'Hot'
  }, {
    rfqNo: 'RFQ-2024-1856',
    oem: 'Tata Motors',
    project: 'Nexon EV Max - Battery Pack',
    productLine: 'Electrical',
    rfqDate: '18-Sep-2024',
    stage: 'Tech Review',
    value: 425,
    probability: 65,
    expectedSOP: 'Q3 FY26',
    owner: 'Priya Sharma',
    status: 'Warm'
  }, {
    rfqNo: 'RFQ-2024-1862',
    oem: 'Hyundai',
    project: 'Venue Facelift - Bumper Assembly',
    productLine: 'Polymer',
    rfqDate: '20-Sep-2024',
    stage: 'Quote Submitted',
    value: 198,
    probability: 80,
    expectedSOP: 'Q1 FY26',
    owner: 'Amit Patel',
    status: 'Hot'
  }, {
    rfqNo: 'RFQ-2024-1875',
    oem: 'Mahindra',
    project: 'Scorpio N - Safety Systems',
    productLine: 'Safety',
    rfqDate: '22-Sep-2024',
    stage: 'RFQ Received',
    value: 165,
    probability: 45,
    expectedSOP: 'Q4 FY26',
    owner: 'Suresh Reddy',
    status: 'Cold'
  }, {
    rfqNo: 'RFQ-2024-1889',
    oem: 'Kia',
    project: 'Seltos EV - Wiring Harness',
    productLine: 'Electrical',
    rfqDate: '25-Sep-2024',
    stage: 'Tech Review',
    value: 225,
    probability: 70,
    expectedSOP: 'Q2 FY26',
    owner: 'Neha Singh',
    status: 'Warm'
  }, {
    rfqNo: 'RFQ-2024-1895',
    oem: 'Honda',
    project: 'City Hybrid - Interior Trim',
    productLine: 'Polymer',
    rfqDate: '28-Sep-2024',
    stage: 'Quote Submitted',
    value: 145,
    probability: 85,
    expectedSOP: 'Q1 FY26',
    owner: 'Vikram Mehta',
    status: 'Hot'
  }, {
    rfqNo: 'RFQ-2024-1902',
    oem: 'Toyota',
    project: 'Innova Crysta EV - Lighting',
    productLine: 'Lighting',
    rfqDate: '01-Oct-2024',
    stage: 'RFQ Received',
    value: 268,
    probability: 50,
    expectedSOP: 'Q3 FY26',
    owner: 'Anjali Desai',
    status: 'Cold'
  }, {
    rfqNo: 'RFQ-2024-1918',
    oem: 'VW Group',
    project: 'Virtus GT - Door Handles',
    productLine: 'Polymer',
    rfqDate: '03-Oct-2024',
    stage: 'Tech Review',
    value: 118,
    probability: 60,
    expectedSOP: 'Q4 FY26',
    owner: 'Rahul Joshi',
    status: 'Warm'
  }, {
    rfqNo: 'RFQ-2024-1925',
    oem: 'MG Motor',
    project: 'Astor Facelift - ECU Systems',
    productLine: 'Electrical',
    rfqDate: '05-Oct-2024',
    stage: 'Quote Submitted',
    value: 185,
    probability: 75,
    expectedSOP: 'Q2 FY26',
    owner: 'Sanjay Gupta',
    status: 'Hot'
  }, {
    rfqNo: 'RFQ-2024-1932',
    oem: 'Renault',
    project: 'Duster EV - Battery Enclosure',
    productLine: 'Electrical',
    rfqDate: '08-Oct-2024',
    stage: 'RFQ Received',
    value: 298,
    probability: 40,
    expectedSOP: 'Q1 FY27',
    owner: 'Pooja Iyer',
    status: 'Cold'
  }];
  const getStageColor = (stage: string) => {
    switch (stage) {
      case 'Won / Awarded':
        return 'text-green-600 bg-green-50 border-green-300';
      case 'Quote Submitted':
        return 'text-blue-600 bg-blue-50 border-blue-300';
      case 'Tech Review':
        return 'text-yellow-600 bg-yellow-50 border-yellow-300';
      case 'RFQ Received':
        return 'text-gray-600 bg-gray-50 border-gray-300';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-300';
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Hot':
        return 'text-red-600 bg-red-50 border-red-300';
      case 'Warm':
        return 'text-orange-600 bg-orange-50 border-orange-300';
      case 'Cold':
        return 'text-blue-600 bg-blue-50 border-blue-300';
      case 'On Track':
        return 'text-green-600 bg-green-50';
      case 'At Risk':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };
  const getProductLineColor = (productLine: string) => {
    switch (productLine) {
      case 'Lighting':
        return 'bg-blue-100 text-blue-800';
      case 'Polymer':
        return 'bg-green-100 text-green-800';
      case 'Electrical':
        return 'bg-yellow-100 text-yellow-800';
      case 'Safety':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getProbabilityColor = (probability: number) => {
    if (probability >= 75) return 'text-green-600 font-bold';
    if (probability >= 60) return 'text-yellow-600 font-semibold';
    return 'text-gray-600';
  };
  return <div data-id="element-8448">
      <DescriptionPanel title="New Business / RFQ Pipeline" description="Comprehensive tracking of Request for Quotation (RFQ) opportunities from initial receipt through technical review, quote submission, and final award. Monitor pipeline health, win rates, and upcoming Start of Production (SOP) milestones." insights={['Pipeline value at ₹4,850 Cr with 68 active RFQs across all stages', 'Win rate improved to 38.5% - 4.2% better than last year', '12 projects confirmed for SOP in next 6 months worth ₹1,636 Cr', 'Maruti Suzuki and Tata Motors leading opportunity pipeline at ₹865 Cr combined']} data-id="element-8449" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-8450">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-8451">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-8452">
              <div className="flex flex-col h-full" data-id="element-8453">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-8454">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-8455">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-8456">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-8457">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-8458" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-8459" />}
                  {kpi.change} vs last year
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* RFQ Funnel */}
      <Card className="p-6 mb-8" data-id="element-8460">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-8461">
          RFQ Pipeline Funnel
        </h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-8462">
          Conversion through stages (₹ Cr)
        </p>
        <div className="space-y-4 py-4" data-id="element-8463">
          {funnelData.map((stage, index) => <div key={index} className="relative" data-id="element-8464">
              <div className="flex items-center justify-between mb-2" data-id="element-8465">
                <div className="flex items-center" data-id="element-8466">
                  <span className="text-sm font-medium text-gray-700" data-id="element-8467">
                    {stage.stage}
                  </span>
                  <span className="ml-2 text-xs text-gray-500" data-id="element-8468">
                    ({stage.count} RFQs)
                  </span>
                </div>
                <span className="text-sm font-semibold text-gray-800" data-id="element-8469">
                  ₹{stage.value} Cr
                </span>
              </div>
              <div className="relative h-14 bg-gray-100 rounded-lg overflow-hidden" data-id="element-8470">
                <div className={`h-full ${stage.color} flex items-center justify-between px-4 transition-all duration-500`} style={{
              width: `${stage.percentage}%`
            }} data-id="element-8471">
                  <span className="text-white font-medium text-sm" data-id="element-8472">
                    {stage.percentage}%
                  </span>
                  {index < funnelData.length - 1 && <span className="text-white text-xs" data-id="element-8473">
                      →{' '}
                      {Math.round(funnelData[index + 1].value / stage.value * 100)}
                      % conversion
                    </span>}
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8474">
          <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-8475">
            <div className="text-center" data-id="element-8476">
              <div className="text-gray-600" data-id="element-8477">Overall Conversion</div>
              <div className="text-xl font-bold text-green-600" data-id="element-8478">38.5%</div>
            </div>
            <div className="text-center" data-id="element-8479">
              <div className="text-gray-600" data-id="element-8480">Avg Deal Size</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-8481">₹71.3 Cr</div>
            </div>
            <div className="text-center" data-id="element-8482">
              <div className="text-gray-600" data-id="element-8483">Active RFQs</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-8484">68</div>
            </div>
          </div>
        </div>
      </Card>
      {/* SOP Timeline Calendar */}
      <Card className="p-6 mb-8" data-id="element-8485">
        <div className="flex items-center justify-between mb-4" data-id="element-8486">
          <div data-id="element-8487">
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-8488">
              SOP Calendar - Next 6 Months
            </h3>
            <p className="text-sm text-gray-600" data-id="element-8489">
              Upcoming Start of Production milestones
            </p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-8490">
            <CalendarIcon size={20} className="text-blue-600" data-id="element-8491" />
            <span className="text-sm font-semibold text-blue-600" data-id="element-8492">
              12 Projects
            </span>
          </div>
        </div>
        <div className="space-y-3" data-id="element-8493">
          {sopTimelineData.map((project, index) => <div key={index} className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8494">
              <div className="flex-shrink-0 w-24 text-center" data-id="element-8495">
                <div className="text-xs font-semibold text-gray-500 uppercase" data-id="element-8496">
                  {project.sop}
                </div>
                <div className="text-lg font-bold text-gray-900 mt-1" data-id="element-8497">
                  {project.month === 1 && 'Nov'}
                  {project.month === 2 && 'Dec'}
                  {project.month === 3 && 'Jan'}
                  {project.month === 4 && 'Feb'}
                  {project.month === 5 && 'Mar'}
                  {project.month === 6 && 'Apr'}
                  {project.month === 7 && 'May'}
                </div>
              </div>
              <div className="flex-grow ml-4" data-id="element-8498">
                <div className="flex items-center justify-between mb-1" data-id="element-8499">
                  <div className="text-sm font-semibold text-gray-900" data-id="element-8500">
                    {project.project}
                  </div>
                  <div className="text-sm font-bold text-gray-900" data-id="element-8501">
                    ₹{project.value} Cr
                  </div>
                </div>
                <div className="flex items-center space-x-2" data-id="element-8502">
                  <span className="text-xs text-gray-600" data-id="element-8503">{project.oem}</span>
                  <span className="text-xs text-gray-400" data-id="element-8504">•</span>
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(project.status)}`} data-id="element-8505">
                    {project.status}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 ml-4" data-id="element-8506">
                <div className="w-2 h-16 bg-gradient-to-b from-blue-400 to-blue-600 rounded-full" data-id="element-8507" />
              </div>
            </div>)}
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8508">
          <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-8509">
            <div className="text-center" data-id="element-8510">
              <div className="text-gray-600" data-id="element-8511">Total SOP Value</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-8512">₹1,636 Cr</div>
            </div>
            <div className="text-center" data-id="element-8513">
              <div className="text-gray-600" data-id="element-8514">On Track</div>
              <div className="text-xl font-bold text-green-600" data-id="element-8515">10</div>
            </div>
            <div className="text-center" data-id="element-8516">
              <div className="text-gray-600" data-id="element-8517">At Risk</div>
              <div className="text-xl font-bold text-red-600" data-id="element-8518">2</div>
            </div>
          </div>
        </div>
      </Card>
      {/* OEM RFQ Opportunity by Product Line */}
      <Card className="p-6 mb-8" data-id="element-8519">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8520">
          OEM RFQ Opportunity by Product Line (₹ Cr)
        </h3>
        <ResponsiveContainer width="100%" height={350} data-id="element-8521">
          <BarChart data={oemProductLineData} data-id="element-8522">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8523" />
            <XAxis dataKey="oem" tick={{
            fontSize: 11,
            angle: -45,
            textAnchor: 'end'
          }} height={100} data-id="element-8524" />
            <YAxis tick={{
            fontSize: 12
          }} data-id="element-8525" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} formatter={(value: number) => `₹${value} Cr`} data-id="element-8526" />
            <Legend data-id="element-8527" />
            <Bar dataKey="lighting" stackId="a" fill="#3b82f6" name="Lighting" data-id="element-8528" />
            <Bar dataKey="polymer" stackId="a" fill="#10b981" name="Polymer" data-id="element-8529" />
            <Bar dataKey="electrical" stackId="a" fill="#f59e0b" name="Electrical" data-id="element-8530" />
            <Bar dataKey="safety" stackId="a" fill="#ef4444" name="Safety" data-id="element-8531" />
          </BarChart>
        </ResponsiveContainer>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8532">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-8533">
            <div className="text-center" data-id="element-8534">
              <div className="text-gray-600" data-id="element-8535">Lighting</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-8536">₹1,296 Cr</div>
            </div>
            <div className="text-center" data-id="element-8537">
              <div className="text-gray-600" data-id="element-8538">Polymer</div>
              <div className="text-xl font-bold text-green-600" data-id="element-8539">₹1,041 Cr</div>
            </div>
            <div className="text-center" data-id="element-8540">
              <div className="text-gray-600" data-id="element-8541">Electrical</div>
              <div className="text-xl font-bold text-yellow-600" data-id="element-8542">₹1,033 Cr</div>
            </div>
            <div className="text-center" data-id="element-8543">
              <div className="text-gray-600" data-id="element-8544">Safety</div>
              <div className="text-xl font-bold text-red-600" data-id="element-8545">₹776 Cr</div>
            </div>
          </div>
        </div>
      </Card>
      {/* RFQ Status Table */}
      <Card className="p-6" data-id="element-8546">
        <div className="flex items-center justify-between mb-4" data-id="element-8547">
          <div data-id="element-8548">
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-8549">
              RFQ Status Tracker
            </h3>
            <p className="text-sm text-gray-600" data-id="element-8550">
              Active opportunities with key details
            </p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-8551">
            <TrophyIcon size={20} className="text-yellow-600" data-id="element-8552" />
            <span className="text-sm font-semibold text-gray-900" data-id="element-8553">
              10 Active RFQs
            </span>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-8554">
          <table className="w-full" data-id="element-8555">
            <thead data-id="element-8556">
              <tr className="border-b-2 border-gray-300" data-id="element-8557">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8558">
                  RFQ No
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8559">
                  OEM
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8560">
                  Project
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8561">
                  Product Line
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8562">
                  RFQ Date
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8563">
                  Stage
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8564">
                  Value
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8565">
                  Win Prob
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8566">
                  Expected SOP
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8567">
                  Owner
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8568">
                  Status
                </th>
              </tr>
            </thead>
            <tbody data-id="element-8569">
              {rfqStatusData.map((item, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-8570">
                  <td className="py-3 px-4 text-sm font-medium text-blue-600" data-id="element-8571">
                    {item.rfqNo}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-800" data-id="element-8572">
                    {item.oem}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-800" data-id="element-8573">
                    {item.project}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8574">
                    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getProductLineColor(item.productLine)}`} data-id="element-8575">
                      {item.productLine}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-8576">
                    {item.rfqDate}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8577">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold border ${getStageColor(item.stage)}`} data-id="element-8578">
                      {item.stage}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-gray-900" data-id="element-8579">
                    ₹{item.value} Cr
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8580">
                    <span className={`text-sm ${getProbabilityColor(item.probability)}`} data-id="element-8581">
                      {item.probability}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-8582">
                    {item.expectedSOP}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-8583">
                    {item.owner}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8584">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold border ${getStatusColor(item.status)}`} data-id="element-8585">
                      {item.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8586">
          <div className="grid grid-cols-5 gap-4 text-sm" data-id="element-8587">
            <div className="text-center" data-id="element-8588">
              <div className="text-gray-600" data-id="element-8589">Total RFQs</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-8590">10</div>
            </div>
            <div className="text-center" data-id="element-8591">
              <div className="text-gray-600" data-id="element-8592">Total Value</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-8593">₹2,314 Cr</div>
            </div>
            <div className="text-center" data-id="element-8594">
              <div className="text-gray-600" data-id="element-8595">Hot Leads</div>
              <div className="text-xl font-bold text-red-600" data-id="element-8596">4</div>
            </div>
            <div className="text-center" data-id="element-8597">
              <div className="text-gray-600" data-id="element-8598">Warm Leads</div>
              <div className="text-xl font-bold text-orange-600" data-id="element-8599">3</div>
            </div>
            <div className="text-center" data-id="element-8600">
              <div className="text-gray-600" data-id="element-8601">Avg Win Prob</div>
              <div className="text-xl font-bold text-green-600" data-id="element-8602">64.5%</div>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};
export default NewBusinessPipelineDashboard;